import { FilterKey, FilterType } from '@ftr/lists'

export enum ReportFilterDateCountInterval {
  Month = 'month',
  Relative = 'PT',
  Day = 'day',
  DayRange = 'dayRange',
}

export enum ReportFilterRelativeDateRangeKey {
  Yesterday = 'd1',
  LastSevenDays = 'd7',
  LastTwentyEightDays = 'd28',
  ThisQuarter = 'q0',
  LastQuarter = 'q1',
  YearToDate = 'y0',
  LastYear = 'y1',
}

export const ReportFilterTypeMapping = {
  [FilterType.Location]: [FilterKey.Courthouse, FilterKey.Courtroom],
  [FilterType.Department]: [FilterKey.Department],
  [FilterType.UserGroup]: [FilterKey.UserGroup],
  [FilterType.UserType]: [FilterKey.UserType],
  [FilterType.Date]: [FilterKey.DateFrom, FilterKey.DateTo, FilterKey.DateCountInterval],
  [FilterType.AdvancedFilters]: [],
}
